'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
class BlockLastTestimonies extends _react.Component {
  state = {
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchTestimonies();
  }
  fetchTestimonies = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/testimony/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        testimonies: response.testimonies
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || error);
      component.setState({
        loading: false,
        info: undefined,
        error: response?.error,
        warning: response?.warning
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.testimonies) return null;
    const slider_settings = {
      dots: false,
      infinite: true,
      speed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 15000,
      useCSS: true,
      breakpoint: 100,
      arrows: true,
      adaptiveHeight: true
    };
    const testimonies = (state.testimonies || []).filter(testimony => testimony.type === props.type).map(function (testimony) {
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-item__slide c-item__slide--testimony",
        key: testimony.id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-testimony"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-testimony__txt",
        dangerouslySetInnerHTML: {
          __html: testimony.comment
        }
      }), testimony.author ? /*#__PURE__*/_react.default.createElement("div", {
        className: "c-testimony__author"
      }, testimony.author) : undefined));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-testimonies"
    }, /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({
      className: "u-full-width testimonies-slider"
    }, slider_settings), testimonies));
    return output;
  }
}
exports.default = BlockLastTestimonies;
